import React from "react";

import { BonusBalanceCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function bonusBalance({ width, onResize }: Column.Options) {
	return base(ColumnId.BonusBalance, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default bonusBalance;
